import {createTheme} from "@mui/material";

const primaryColor = "#d75847";
const secondaryColor = "#333333";
const customGreen = "#6ad3a4";
const customWhite = "#ffffff";
const customBlue = "#2361c5";
const customLightBlue = "#95b7f0";
const customDisabledGray = "#7f7f7f";
const customGray = "#999999";
const customLightGray = "#cccccc";
const customBackgroundGray = "#f7f7f7";
const hoverGray = "#ebebeb";
const activeBackground = "#efd7d6";

const theme = createTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: secondaryColor
        },
        success: {
            main: customGreen
        },
        error: {
            main: primaryColor,
        },
        text: {
            primary: secondaryColor,
            secondary: customWhite,
        },
        custom: {
            customBlue: customBlue,
            customLightBlue: customLightBlue,
            customGreen: customGreen,
            customWhite: customWhite,
            customGray: customGray,
            customLightGray: customLightGray,
            customBackgroundGray: customBackgroundGray,
            customDisabledGray: customDisabledGray,
            hoverGray: hoverGray,
            activeBackground: activeBackground,
        },
    },
    typography: {
        fontFamily: "'Lato', 'sans-serif'",
        allVariants: {
            color: secondaryColor
        },
        linkPrimary: {
            fontSize: '16px',
        },
        linkSecondary: {
            fontSize: '12px',
        },
        explanation: {
            fontSize: '12px',
            color: customGray
        },
        h1: {
            fontSize: '34px',
            fontWeight: 'bold',
        },
        h5: {
            fontWeight: 'bold',
        },
        h6: {
            fontWeight: 'bold',
        },
        button: {
            fontWeight: 'bold',
        }
    },
    components: {
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: secondaryColor, // Farbe wenn nicht ausgewählt
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                dense: {
                    height: 48,
                    minHeight: 48
                }
            }
        }
    }
});

export default theme;